<template>

    <div class="page p-calendar">
        <the-dashboard-heading>
            <h2>Kalendarz</h2>
        </the-dashboard-heading>

        <the-dashboard-content class="p-calendar__content">
            <calendar-main class="p-calendar__calendar"></calendar-main>
        </the-dashboard-content>

        <v-calendar-legend></v-calendar-legend>
    </div>

</template>


<script>

import store from 'Store'
import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'
import CalendarMain from 'Components/Calendar/CalendarMain'
import VCalendarLegend from 'Components/VCalendarLegend'

export default {

    name: 'CalendarIndex',

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        store.dispatch('EVENTS_RESET')
        Promise.all([
            store.dispatch('PATIENTS_LIST_FETCH'),
            store.dispatch('EVENT_RESET'),
            store.dispatch('PHT_OFFICES_FETCH'),
        ]).then(() => {
            store.dispatch('PAGE_LOADING_RESET')
            next()
        })
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        CalendarMain,
        VCalendarLegend
    }
}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-calendar {
    min-height: 100%;
    padding-bottom: 0;

    &__content {
        @include bp($screen-lg) {
            flex-grow: 0 !important;
        }
    }
    &__calendar {
        width: 100%;
    }
}

</style>
